module.exports = __webpack_public_path__ + "img/search-maps-desktop.a727c23a.svg";